import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { UI_TEXT } from "@/lib/i18n";

const LanguageContext = createContext(null);

const STORAGE_KEY = "site-language";

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "en" || saved === "tr" ? saved : "tr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, language);
      document.documentElement.lang = language;
    }
  }, [language]);

  const toggleLanguage = () => setLanguage((prev) => (prev === "tr" ? "en" : "tr"));

  const t = useMemo(() => {
    return (key) => {
      const entry = UI_TEXT[key];
      if (!entry) return key;
      return entry[language] ?? entry.tr ?? key;
    };
  }, [language]);

  const value = useMemo(
    () => ({ language, setLanguage, toggleLanguage, t }),
    [language, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
  return ctx;
};

export default LanguageContext;
